export const breakpointColumnsObj = {
  default: 3,
  900: 2,
  600: 1,
}
